<template>
  <VCarManagerTable />
</template>
<script>
import VCarManagerTable from '@/components/CarManager/VCarManagerTable.vue'
export default {
  name: 'CarManager',

  components: {
    VCarManagerTable
  }
}
</script>
